import { render, staticRenderFns } from "./CFBeneficialOwnersV2.vue?vue&type=template&id=5a52358b&scoped=true&"
import script from "./CFBeneficialOwnersV2.vue?vue&type=script&lang=js&"
export * from "./CFBeneficialOwnersV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a52358b",
  null
  
)

export default component.exports